/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelSalespersonReassign.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/crm/salesperson-reassign";

export class AutogenModelSalespersonReassign<RowType extends ModelRow> extends Endpoint<RowType, RowSalespersonReassignFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowSalespersonReassign extends ModelRow<RowSalespersonReassignFields> {
	constructor(values?: Partial<RowSalespersonReassignFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowSalespersonReassignFields {
	activity_count: number;
	activity_days: number;
	activity_reset: string;
	cc_frmr_salesmgr: string;
	cc_frmr_salesperson: string;
	cc_salesmgr: string;
	company_id: string;
	date_type: string;
	descr: string;
	email: string;
	id: string;
	order_count: number;
	order_days: number;
	revenue: number;
	revenue_c: string;
	revenue_d: Date;
	revenue_days: number;
	revenue_n: number;
	revenue_r: number;
	"salesperson.address": string;
	"salesperson.city": string;
	"salesperson.commission_payee_id": string;
	"salesperson.company_id": string;
	"salesperson.id": string;
	"salesperson.is_manager": string;
	"salesperson.name": string;
	"salesperson.percentage": number;
	"salesperson.sales_manager_id": string;
	"salesperson.state": string;
	"salesperson.user_id": string;
	"salesperson.zip_code": string;
	salesperson_id: string;
}

